import { z } from 'zod';

export const editClientAdminUserSchema = z
  .object({
    fullName: z.string().trim().min(1, '氏名を入力してください。'),
    email: z
      .string()
      .trim()
      .min(1, 'メールアドレスを入力してください。')
      .email('有効なメールアドレスを入力してください。'),
    password: z
      .string()
      .min(8, 'パスワードは8文字以上で入力してください。')
      .optional()
      .or(z.literal('')),
    passwordConfirmation: z.string().optional().or(z.literal('')),
  })
  .refine(
    data => {
      if (data.password && data.password.length > 0) {
        return data.password === data.passwordConfirmation;
      }
      return true;
    },
    {
      message: 'パスワードが一致しません。',
      path: ['passwordConfirmation'],
    }
  )
  .refine(data => !(data.passwordConfirmation && !data.password), {
    message: 'パスワードを入力してください。',
    path: ['passwordConfirmation'],
  });

export type EditClientAdminUserFormFieldValues = z.infer<typeof editClientAdminUserSchema>;
